import { render, staticRenderFns } from "./AddItemResult.vue?vue&type=template&id=c852f784&scoped=true&"
import script from "./AddItemResult.vue?vue&type=script&lang=js&"
export * from "./AddItemResult.vue?vue&type=script&lang=js&"
import style0 from "./AddItemResult.vue?vue&type=style&index=0&id=c852f784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c852f784",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
